import { useState } from "react";
import styles from "./ProductCard.module.css";

function ProductCard({
  image,
  name,
  description,
  price,
  onClick,
}) {
  const [imageError, setImageError] = useState(false);

  return (
    <article
      className={styles.card}
      onClick={onClick}
    >
      {!imageError && image && (
        <div className={styles.imageContainer}>
          <img
            className={styles.image}
            src={image}
            alt={name || "Produto Delicices"}
            loading="lazy"
            onError={() => setImageError(true)}
          />
        </div>
      )}

      {(name || description || price) && (
        <div className={styles.content}>
          {name && (
            <h3 className={styles.name}>
              {name}
            </h3>
          )}

          {description && (
            <p className={styles.description}>
              {description}
            </p>
          )}

          {price && (
            <p className={styles.price}>
              {price}
            </p>
          )}
        </div>
      )}
    </article>
  );
}

export default ProductCard;